import ical from "ical-generator";
import { Reservation } from "@/models/storeModel";

// Function to generate an ICS file content
export const generateICSContent = (
  reservation: Reservation,
  storeName: string
) => {
  const calendar = ical({ name: "Reservation Calendar" });

  const startTime = new Date(
    `${reservation.reservation_date}T${reservation.reservation_time}`
  );
  const endTime = new Date(startTime.getTime() + 60 * 60 * 1000); // 1 hour duration

  calendar.createEvent({
    start: startTime,
    end: endTime,
    summary: `Reservation at ${storeName}`,
    description: `
      Reservation Details:
      - Party Size: ${reservation.party_size} guests
      - Special Requests: ${reservation.special_requests || "None"}
      
      Contact Information:
      - Name: ${reservation.customer_name}
      - Phone: ${reservation.customer_phone || "Not provided"}
      - Email: ${reservation.customer_email}
    `,
    location: storeName,
  });

  return calendar.toString();
};

// Function to generate Google Calendar URL
export const generateGoogleCalendarUrl = (
  reservation: Reservation,
  storeName: string
) => {
  const startTime = new Date(
    `${reservation.reservation_date}T${reservation.reservation_time}`
  );
  const endTime = new Date(startTime.getTime() + 60 * 60 * 1000); // 1 hour duration

  const details = `
    Reservation Details:
    - Party Size: ${reservation.party_size} guests
    - Special Requests: ${reservation.special_requests || "None"}
    
    Contact Information:
    - Name: ${reservation.customer_name}
    - Phone: ${reservation.customer_phone || "Not provided"}
    - Email: ${reservation.customer_email}
  `;

  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: `Reservation at ${storeName}`,
    details: details.trim(),
    location: storeName,
    dates: `${startTime.toISOString().replace(/[-:.]/g, "")}/${endTime
      .toISOString()
      .replace(/[-:.]/g, "")}`,
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

// Function to generate Outlook Calendar URL
export const generateOutlookCalendarUrl = (
  reservation: Reservation,
  storeName: string
) => {
  const startTime = new Date(
    `${reservation.reservation_date}T${reservation.reservation_time}`
  );
  const endTime = new Date(startTime.getTime() + 60 * 60 * 1000); // 1 hour duration

  const params = new URLSearchParams({
    path: "/calendar/action/compose",
    rru: "addevent",
    startdt: startTime.toISOString(),
    enddt: endTime.toISOString(),
    subject: `Reservation at ${storeName}`,
    location: storeName,
    body: `
      Reservation Details:
      - Party Size: ${reservation.party_size} guests
      - Special Requests: ${reservation.special_requests || "None"}
      
      Contact Information:
      - Name: ${reservation.customer_name}
      - Phone: ${reservation.customer_phone || "Not provided"}
      - Email: ${reservation.customer_email}
    `.trim(),
  });

  return `https://outlook.office.com/calendar/0/deeplink/compose?${params.toString()}`;
};
